<template>
    <b-card style="height:9999px">        
        <b-card-title>
            
            <div  draggable="true"
                        @dragstart="dragStartTourList($event)"
                        @dragover.prevent>
                        <b-button size="sm" variant="light" @click="toggleExpandAll">
                            <i class="fa-solid fa-angles-down"></i>
                        </b-button>
                        Turlista</div>
                        <slot></slot>
        </b-card-title>
        <b-card-body>
                        
            <b-row v-for="(t,i) in tours" :key="i"
                            @click="toggleExpand(t)"
                                    draggable="true"
                                        @dragstart="dragStartTour($event,t)"
                                        @dragover.prevent
                                        @drop="drop($event,t,null,i)"
                            >

                                <!-- {{ t }} -->
                                <!-- <b-button block variant="outline-primary"
                                    @click="toggleExpand(t)"
                                    draggable="true"
                                        @dragstart="dragStartTour($event,t)"
                                        @dragover.prevent
                                        @drop="drop($event,t,r,i)"
                                    >{{ getText(t) }}          
                                </b-button> -->
                <b-col>
                    <b-row>
                        <b-col>
                                <b-dropdown
                                    :text="getText(t)"
                                    block
                                    split
                                    split-variant="outline-primary"
                                    variant="primary"
                                    class="m-2"
                                >
                                <!-- routeactions -->
                                
                                <b-dropdown-item v-for="(ta,i) in getTourActions()" :key="i" href="#" @click="handleTourAction(ta,t)">{{ta.title}}</b-dropdown-item>
                                    <!-- <b-dropdown-item href="#">Action</b-dropdown-item>
                                    <b-dropdown-item href="#">Another action</b-dropdown-item>
                                    <b-dropdown-item href="#">Something else here...</b-dropdown-item> -->
                                </b-dropdown>
                        </b-col>
                    </b-row>
                
                <b-row  v-if="t.expanded">
                    <b-card>
                    <b-card-body>
                        <b-row v-for="(r,i) in t.routes" :key="i">
                        <b-button block 
                        draggable="true"
                        @dragstart="dragStart($event,r,t)"
                        @dragover.prevent
                        @drop="drop($event,t,r,i)"
                                            >
                            {{ getText(r) }}
                            <b-badge v-if="r.stops&&r.stops.length>2" variant="success" title="Antal stopp">{{ r.stops.length-2 }}</b-badge>
                            <b-badge v-if="r.missingGeos&&r.missingGeos.length>0" variant="danger" title="Saknar geokodning">{{ r.missingGeos.length }}</b-badge>
                        </b-button>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-row>
        </b-col>
            </b-row>            
        </b-card-body>
    </b-card>
</template>
<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
<script>

export default {
    name:'tourlist',
    props: { tours: Array, touractions: Array},
    methods: {
        getTourActions() {
            if(this.touractions)
                return this.touractions;
            return [];
        },
        getText(r) {
            return r.name ? r.name.replaceAll(',',', ') : '-';
        },
        toggleExpand(t) {
            //t.expanded=!t.expanded;
            var newVal = !t.expanded;
            this.$emit('expand', {tour: t, expanded: newVal})
        },
        dragStart(ev, r,t) {
           //this.draggedItem = this.items[index];
           if(ev)
                ev.stopPropagation();

           console.log('drag start');
           //ev.dataTransfer.setData("Text", {text:'En text', index: index});
           this.$emit('setdrag',{type: 'route', route: r, tour: t}, )
        }, 
        dragStartTour(ev,t) {           
           console.log('drag start tour');
           console.log(t);
           //ev.dataTransfer.setData("Text", {text:'En text', index: index});
           this.$emit('setdrag',{type: 'tour', tour: t})
        },
        dragStartTourList(ev) {
            this.$emit('setdrag',{type: 'tourlist'})
        },
        drop(ev,tour,route,i) {
            
            this.$emit('drop',{type: 'tour',tour:tour,route:route})
            // alert('Dropped!!!');
        },
        toggleExpandAll() {
            if(this.tours.length>0) {
                var newVal = !this.tours[0].expanded;
                this.tours.map(t=>this.$emit('expand', {tour: t, expanded: newVal}));
            }
        },
        handleTourAction(ta,t) {
            this.$emit('touraction',{cmd:ta.cmd,tour:t});
        }
    }
}

</script>